import { Pipe, PipeTransform } from '@angular/core';
import { CaseModuleId, CMOrderModuleId, ContactModuleId, CustomerRMAModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, OpportunityModuleId, SOModuleId, TaskModuleId } from '../constants/modules.constant';
@Pipe({ name: 'activityModuleName', pure: true })
export class ActivityModuleNamePipe implements PipeTransform {

    transform(activityDetails: any): any {
        let moduleDetails: string = "";
        switch (activityDetails?.moduleData?.objectId) {
            case OpportunityModuleId:
                moduleDetails = `Opportunity ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            case ContactModuleId:
                moduleDetails = `Contact ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            case CaseModuleId:
                moduleDetails = `Case ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            case TaskModuleId:
                moduleDetails = `Task ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            case SOModuleId:
                moduleDetails = `SalesOrder ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            case InvoiceOrderModuleId:
                moduleDetails = `Invoice ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            case CustomerRMAModuleId:
                moduleDetails = `CustomerRMA ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            case CMOrderModuleId:
                moduleDetails = `CreditMemo ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            case EstimateOrderModuleId:
                moduleDetails = `Estimate ${activityDetails?.moduleData?.sequenceNumber||''}`;
                break;
            default:
                break;
        }

        return moduleDetails||activityDetails?.type;
    }
}
